/**
 * DiffContext provides diff annotations to child components.
 *
 * This is a separate context from CarePlanContext — the diff layer is
 * orthogonal to step rendering. StepCard renders from CarePlanContext
 * as usual; DiffStepWrapper reads from DiffContext to add visual
 * decorations around the card.
 */
import { createContext, useContext } from "react";
import { type DiffAnnotation, type FieldChange } from "./types";
export interface DiffContextType {
  annotations: Map<string, DiffAnnotation>;
  carePlanChanges: FieldChange[];
}
export const DiffContext = createContext<DiffContextType | null>(null);
export function useDiffContext() {
  const ctx = useContext(DiffContext);
  if (!ctx) {
    throw new Error("useDiffContext must be used within a DiffContext.Provider");
  }
  return ctx;
}